import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApiErrorCode, ServiceURLConstants } from "../constants/upplm.constants";
import { UpsCommonService } from "./upplm.common.service";

@Injectable()

export class CommonUserAttributesService {
    constructor(private _httpclient: HttpClient,
        private _commonService: UpsCommonService    ) { }

    async getUserInformation() {
        return await this._httpclient.post<any>(this._commonService.createURL(ServiceURLConstants.GET_COMMON_USER_ATTRIBUTES, ApiErrorCode.GET_COMMON_USER_ATTRIBUTES),
    null).toPromise();
    }
}